"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SmartTestimonialsSection;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _function = require("./function");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _videoLightbox = _interopRequireDefault(require("../../../page-body/media-components/video-lightbox"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _reactIntersectionObserver = require("react-intersection-observer");
var _trustpilotSection = _interopRequireDefault(require("./trustpilot-section"));
var _smartTestimonialsCard = _interopRequireDefault(require("./smart-testimonials-card"));
var _motionMove = _interopRequireDefault(require("../../../experiments/animation/motion-move"));
var _carouselControl = _interopRequireDefault(require("./carousel-control.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Testimonial = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "Testimonial",
  class: "pl-t1tsgjsb"
});
const TestimonialWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TestimonialWrapper",
  class: "pl-t1ychxc"
});
const SliderWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SliderWrapper",
  class: "pl-s1aze4po"
});
const SlideGallery = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SlideGallery",
  class: "pl-sfd1jby"
});
const BelowCardsWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "BelowCardsWrapper",
  class: "pl-bznnq5e"
});

/**
 * Renders Smart Testimonials Section
 * @module SmartTestimonialsSection
 *
 * @param {Object} props React props for Smart Testimonials Section
 * @param {string} props.heading Section headline text
 * @param {array} props.cards Array of Smart Testimonials Cards
 * @param {string} props.prevButtonAriaLabel ARIA label for prev button
 * @param {string} props.nextButtonAriaLabel ARIA label for next button
 * @returns {React.ReactElement} Smart Testimonials Section
 * @public
 */
function SmartTestimonialsSection({
  _name,
  verticalMargin,
  heading,
  cards,
  prevButtonAriaLabel = 'Previous card',
  nextButtonAriaLabel = 'Next card',
  altTextForReviewStars,
  ...trustpilotProps
}) {
  const [containerWidth, setContainerWidth] = (0, _react.useState)(0);
  const [slidesWidth, setSlidesWidth] = (0, _react.useState)(0);
  const [slideCardWidth, setSlideCardWidth] = (0, _react.useState)(0);
  const [showModal, setShowModal] = (0, _react.useState)(false);
  const [lightboxUrl, setLightboxUrl] = (0, _react.useState)('');
  const slidesRef = (0, _react.useRef)();
  const width = (0, _patternLibraryUtils.useWindowSize)();
  const {
    ref,
    inView
  } = (0, _reactIntersectionObserver.useInView)({
    triggerOnce: true
  });
  const vwToPx = (viewportWidth, vw) => vw * viewportWidth / 100;
  const handlePrevButtonClick = () => {
    const xPosition = (0, _function.translateXForElement)(slidesRef.current);
    const newXPosition = xPosition + slideCardWidth;
    const endPoint = 0;
    slidesRef.current.style.transform = `translateX(${Math.min(newXPosition, endPoint)}px)`;
    slidesRef.current.style.transition = 'transform 0.5s';
  };
  const handleNextButtonClick = () => {
    const xPosition = (0, _function.translateXForElement)(slidesRef.current);
    const newXPosition = xPosition - slideCardWidth;
    const endPoint = containerWidth - slidesWidth - vwToPx(containerWidth, 8);
    slidesRef.current.style.transform = `translateX(${Math.max(newXPosition, endPoint)}px)`;
    slidesRef.current.style.transition = 'transform 0.5s';
  };
  (0, _react.useEffect)(() => {
    const slider = slidesRef.current;
    if (inView && slider && slider.children[0]) {
      setSlidesWidth(slider.clientWidth);
      setContainerWidth(window.innerWidth);
      setSlideCardWidth(slider.children[0].clientWidth);
    }
  }, [inView, width]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Testimonial, {
    dataCy: "smart-testimonials-section",
    _name: _name,
    verticalMargin: verticalMargin
  }, /*#__PURE__*/_react.default.createElement(_motionMove.default, {
    mode: "fluid",
    intensity: "300",
    variant: "moveUpFixed",
    staggerChildren: true,
    triggerOnce: true
  }, /*#__PURE__*/_react.default.createElement(_index.default, {
    heading: heading,
    headlineSize: "h2",
    headlineLineLength: 1.5,
    headlineTag: "h2",
    textAlign: "start"
  }), /*#__PURE__*/_react.default.createElement(TestimonialWrapper, {
    ref: ref
  }, /*#__PURE__*/_react.default.createElement(SliderWrapper, {
    "data-cy": "slide-wrapper",
    ref: slidesRef,
    style: {
      x: 0
    }
  }, cards?.map((item, index) => /*#__PURE__*/_react.default.createElement(SlideGallery, {
    key: index
  }, /*#__PURE__*/_react.default.createElement(_smartTestimonialsCard.default, (0, _extends2.default)({
    setLightboxUrl: setLightboxUrl,
    handlePlay: () => setShowModal(true)
  }, item))))), /*#__PURE__*/_react.default.createElement(BelowCardsWrapper, null, /*#__PURE__*/_react.default.createElement(_trustpilotSection.default, (0, _extends2.default)({}, trustpilotProps, {
    altTextForReviewStars: altTextForReviewStars
  })), cards.length > 3 && /*#__PURE__*/_react.default.createElement(_carouselControl.default, {
    handleNextButtonClick,
    handlePrevButtonClick,
    prevButtonAriaLabel,
    nextButtonAriaLabel
  }))))), lightboxUrl && /*#__PURE__*/_react.default.createElement(_videoLightbox.default, {
    lightboxUrl: lightboxUrl,
    showModal: showModal,
    handleClose: () => setShowModal(false)
  }));
}
SmartTestimonialsSection.propTypes = {
  _name: _propTypes.default.string,
  heading: _propTypes.default.string,
  cards: _propTypes.default.array.isRequired,
  prevButtonAriaLabel: _propTypes.default.string,
  nextButtonAriaLabel: _propTypes.default.string,
  altTextForReviewStars: _propTypes.default.string.isRequired,
  ..._patternLibraryUtils.marginProps,
  ..._trustpilotSection.default.propTypes
};